<template>
  <div>
    <!-- Hidden input -->
    <input type="hidden" id="dial_number">
    <link href="https://fonts.googleapis.com/css?family=Exo" rel="stylesheet">
    <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css" rel="stylesheet">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.8.55/css/materialdesignicons.min.css" rel="stylesheet">
    <div class="phone-row">
      <div class="phone-container">
        <transfer
          v-if="call.onCall && call.transferInitiated"
          :username = "username"
          :call = "call"
          :transferNumber = "call.transferNumber"
          :transferDigit = "transferDigit"
          :transferClear = "transferClear"
          :transferBackspace = "transferBackspace"
          :cancelTransfer = "cancelTransfer"
          :transferCall = "transferCall"
          :attendedTransferCall = "attendedTransferCall"
          >
        </transfer>
        <on-call
          v-if="call.onCall && !call.transferInitiated"
          :call = "call"
          :username = "username"
          :number = "call.number"
          :hold = "call.hold"
          :mute = "call.mute"
          :timeFormated = "call.timeFormated"
          :holdCall = "holdCall"
          :muteCall = "muteCall"
          :toggleCamera = "toggleCamera"
          :transfer = "transfer"
          :hangupCall = "hangupCall"
          :dtmfNumber = "call.dtmfNumber"
          :dtmfDigit = "dtmfDigit"
          :dtmfClear = "dtmfClear"
          :dtmfBackspace = "dtmfBackspace"
          :merge = "merge"
          :isVideo = "call.isVideo"
          :camera = "call.camera"
          >
        </on-call>
        <dial
          v-if="!call.onCall && !call.transferInitiated"
          :username = "username"
          :number = "call.number"
          :digit = "digit"
          :clear = "clear"
          :backspace = "backspace"
          :makeCall = "makeCall"
          :makeVideoCall = "makeVideoCall"
          :hangupCause = "call.hangupCause"
          :audioOnly = "audioOnly"
          >
        </dial>
      </div>
    </div>
    <div style="left: -320px; top: 0; position: absolute;">
      <div :id="`webcam${sequence}div`">
        <video width="0" height="0" :id="`webcam${sequence}`" autoplay="true"></video>
      </div>
      <div style="margin-top: 36px;" :id="`local_webcam${sequence}div`">
        <video width="0" height="0" :id="`local_webcam${sequence}`" autoplay="true"></video>
      </div>
    </div>
    <b-modal
      ref="callRing"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-backdrop
      >
      <template v-slot:modal-title>
        {{ $t('phone.incoming') }}<span v-if="call.isVideo"> {{ $t('phone.video') }}</span> {{ $t('phone.call') }}
      </template>
      {{ call.incomingNumber }}
      <b-button class="mt-3" variant="danger" block @click="hangupCall"><i class="mdi mdi-phone-hangup"></i>&nbsp;&nbsp;{{ $t('phone.decline') }}</b-button>
      <b-button class="mt-2" variant="success" block @click="answerCall" v-if="call.isVideo"><i class="mdi mdi-phone"></i>&nbsp;&nbsp;{{ $t('phone.answerVoice') }}</b-button>
      <b-button class="mt-2" variant="success" block @click="answerCall" v-else><i class="mdi mdi-phone"></i>&nbsp;&nbsp;{{ $t('phone.answerCall') }}</b-button>
      <b-button class="mt-2" variant="primary" block :disabled="audioOnly" @click="answerVideoCall" v-if="call.isVideo"><i class="mdi mdi-video"></i>&nbsp;&nbsp;{{ $t('phone.answerVideo') }}</b-button>

      <!-- Contact info in ring notification -->
      <!--
      <div v-if="call.contact">
        <hr>
        <img src="https://www.gravatar.com/avatar/?d=mp" style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 20px; width: 25%;" />
        <table style="margin-left: auto; margin-right: auto;">
          <tr>
            <td style="width: 138px;"><b>First Name</b></td>
            <td>{{ call.contact.first_name }}</td>
          </tr>
          <tr>
            <td><b>Last Name</b></td>
            <td>{{ call.contact.last_name }}</td>
          </tr>
          <tr>
            <td><b>Email</b></td>
            <td>{{ call.contact.email }}</td>
          </tr>
          <tr>
            <td><b>Phone</b></td>
            <td>{{ call.contact.phone }}</td>
          </tr>
        </table>
      </div>
      -->
    </b-modal>
    <b-modal
      ref="attendedTransfer"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        <span v-if="call.transferInProgress">
          {{ $t('phone.performingTransfer') }}...
        </span>
        <span v-else>
          {{ $t('phone.transfer') }} {{ call.currentCall ? call.currentCall.params.remote_caller_id_number : '' }} ({{ call.name }}) {{ $t('phone.to') }} {{ call.attendedTransferInitiator }} ({{ call.attendedTransferInitiatorLine }}) ?
          <b-button class="mt-3" variant="danger" block @click="cancelAttendedTransfer">{{ $t('phone.cancel') }}</b-button>
          <b-button class="mt-2" variant="success" block @click="completeAttendedTransfer">{{ $t('phone.completeTransfer') }}</b-button>
          <b-button class="mt-2" variant="primary" block @click="mergeAttendedTransfer">{{ $t('phone.merge') }}</b-button>
        </span>
      </div>
    </b-modal>
    <b-modal
      ref="mergeRequest"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        <span v-if="call.mergeInProgress">
          {{ $t('phone.performingMerge') }}...
        </span>
        <span v-else>
          {{ $t('phone.merge') }} {{ call.currentCall ? call.currentCall.params.remote_caller_id_number : '' }} ({{ call.name }}) {{ $t('phone.and') }} {{ call.mergeCallee &&  call.mergeCallee.currentCall ? call.mergeCallee.currentCall.params.remote_caller_id_number : '' }} ({{ call.mergeCallee ? call.mergeCallee.name : '' }}) ?
          <b-button class="mt-3" variant="danger" block @click="cancelMergeRequest">{{ $t('phone.cancel') }}</b-button>
          <b-button class="mt-2" variant="primary" block @click="completeMergeRequest">{{ $t('phone.merge') }}</b-button>
        </span>
      </div>
    </b-modal>
    <b-modal
      ref="mergeNotAvailable"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        {{ $t('phone.noCalls') }}
        <b-button class="mt-3" variant="danger" block @click="cancelMergeNotAvailable">Okay</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import dial from './components/Dial'
import onCall from './components/OnCall'
import transfer from './components/Transfer'

export default {
  name: 'Phone',
  components: {
    'dial': dial,
    'on-call': onCall,
    'transfer': transfer
  },
  props: {
    sequence: {
      type: Number,
      required: true
    },
    vertoHandle: {
      type: Object,
      required: true
    },
    username: {
      type: String,
      required: true
    },
    caller_id: {
      type: String,
      required: true
    },
    caller_id_name: {
      type: String,
      required: false
    },
    call: {
      type: Object,
      required: true
    },
    attendedTransferCall: {
      type: Function
    },
    completeAttendedTransferCall: {
      type: Function
    },
    mergeAttendedTransferCall: {
      type: Function
    },
    ringInterval: {
      type: Number
    },
    ringKillInterval: {
      type: Number
    },
    ringNotification: {
      type: typeof Notification !== 'undefined' ? Notification : Object
    },
    activeCalls: {
      type: Function
    },
    mergeCalls: {
      type: Function
    },
    windowWidth: {
      type: Number
    },
    changeOnGoingCalls: {
      type: Function
    },
    audioOnly: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  methods: {
    digit (dig) {
      this.call.number = this.call.number + dig
    },
    backspace () {
      var self = this
      if (self.call.number === `DEVCONF${self.username}`) {
        self.call.number = ''
      } else {
        self.call.number = self.call.number.substring(0, self.call.number.length - 1)
      }
    },
    clear () {
      this.call.number = ''
    },
    transferDigit (dig) {
      this.call.transferNumber = this.call.transferNumber + dig
    },
    transferBackspace () {
      this.call.transferNumber = this.call.transferNumber.substring(0, this.call.transferNumber.length - 1)
    },
    transferClear () {
      this.call.transferNumber = ''
    },
    dtmfDigit (dig) {
      var self = this
      self.call.dtmfNumber = self.call.dtmfNumber + dig
      self.call.currentCall.dtmf(dig)
    },
    dtmfBackspace () {
      this.call.dtmfNumber = this.call.dtmfNumber.substring(0, this.call.dtmfNumber.length - 1)
    },
    dtmfClear () {
      this.call.dtmfNumber = ''
    },
    toggleTimer (flag) {
      var self = this
      if (flag) {
        self.call.interval = setInterval(self.incrementTime, 1000)
      } else {
        clearInterval(self.call.interval)
        self.call.time = 0
        self.call.timeFormated = ''
      }
    },
    incrementTime () {
      var self = this
      self.call.time = parseInt(this.call.time) + 1

      var measuredTime = new Date(null)
      measuredTime.setSeconds(self.call.time)
      self.call.timeFormated = measuredTime.toISOString().substr(11, 8)
    },
    makeCall () {
      var self = this
      const dial_number = document.getElementById('dial_number').value
      if (!self.call.number || self.call.number.length <= 0 && (dial_number && dial_number.length > 0)) {
        self.call.number = dial_number
        document.getElementById('dial_number').value = ''
      }
      self.call.onCall = true
      self.changeOnGoingCalls(1)
      self.call.currentCall = self.vertoHandle.newCall({
        destination_number: self.call.number.replace('+', ''),
        caller_id_name: self.caller_id_name || self.caller_id,
        caller_id_number: self.username,
        useVideo: false,
        localVideo: false,
        tag: `webcam${self.sequence}`
      })
      self.call.direction = 'Outbound'
      self.isHistory = false
    },
    makeVideoCall () {
      var self = this
      self.call.onCall = true
      self.changeOnGoingCalls(1)
      self.call.isVideo = true
      self.vertoHandle.videoParams({
        width: 320,
        // minWidth: 320,
        // minHeight: 240,
        // maxWidth: 640,
        // maxHeight: 480,
        // minFrameRate: 15,
        // vertoBestFrameRate: 30
      })
      self.vertoHandle.deviceParams({
        useCamera: 'any',
        useMic: 'any',
        useSpeak: 'any'
      })
      self.call.currentCall = self.vertoHandle.newCall({
        destination_number: self.call.number.replace('+', ''),
        caller_id_name: self.caller_id_name || self.caller_id,
        caller_id_number: self.username,
        useVideo: true,
        localVideo: true,
        tag: `webcam${self.sequence}`,
        localTag: `local_webcam${self.sequence}`,
        mirrorInput: true
      })
      self.call.direction = 'Outbound'
      self.isHistory = false

      // Change video size
      var local_webcam = document.getElementById(`local_webcam${self.sequence}`)
      local_webcam.setAttribute('width', '320')
      local_webcam.setAttribute('height', '240')

      var remote_webcam = document.getElementById(`webcam${self.sequence}`)
      remote_webcam.setAttribute('width', '320')
      remote_webcam.setAttribute('height', '240')

      if (self.windowWidth < 800) {
        window.resizeTo(window.innerWidth + 300, 604)
      }
    },
    hangupCall () {
      var self = this
      // var hangupCall = self.currentCall

      // Stop ringing and hide notification
      if (self.ringInterval) {
        clearInterval(self.ringInterval)
        self.$emit('update:ringInterval', null)
      }
      if (self.ringKillInterval) {
        clearInterval(self.ringKillInterval)
        self.$emit('update:ringKillInterval', null)
      }
      if (self.ringNotification) {
        self.ringNotification.close()
        self.$emit('update:ringNotification', null)
      }
      self.call.currentCall.stopRinging()
      self.call.currentCall.hangup()
      self.$refs['callRing'].hide()

      /*
      setTimeout(() => {
        console.log('1 second', hangupCall)
        hangupCall.hangup()
        self.$refs['callRing'].hide()
      }, 1000)

      setTimeout(() => {
        console.log('2 seconds', hangupCall)
        hangupCall.hangup()
        self.$refs['callRing'].hide()
      }, 2000)
      */
    },
    answerCall () {
      var self = this
      self.call.currentCall.answer()

      // Stop ringing and hide notification
      if (self.ringInterval) {
        clearInterval(self.ringInterval)
        self.$emit('update:ringInterval', null)
      }
      if (self.ringKillInterval) {
        clearInterval(self.ringKillInterval)
        self.$emit('update:ringKillInterval', null)
      }
      if (self.ringNotification) {
        self.ringNotification.close()
        self.$emit('update:ringNotification', null)
      }
      self.$refs['callRing'].hide()
      self.call.onCall = true
      self.call.isVideo = false
      self.changeOnGoingCalls(1)
    },
    recoverCall () {
      var self = this
      self.call.currentCall.answer()

      self.call.onCall = true
      self.call.isVideo = false
      self.changeOnGoingCalls(1)
    },
    answerVideoCall () {
      var self = this
      self.call.currentCall.answer({
        useVideo: true,
        // localVideo: true,
        // mirrorInput: true
      })

      // Stop ringing and hide notification
      if (self.ringInterval) {
        clearInterval(self.ringInterval)
        self.$emit('update:ringInterval', null)
      }
      if (self.ringKillInterval) {
        clearInterval(self.ringKillInterval)
        self.$emit('update:ringKillInterval', null)
      }
      if (self.ringNotification) {
        self.ringNotification.close()
        self.$emit('update:ringNotification', null)
      }
      self.$refs['callRing'].hide()
      self.call.onCall = true
      self.changeOnGoingCalls(1)

      // Change video size
      var local_webcam = document.getElementById(`local_webcam${self.sequence}`)
      local_webcam.setAttribute('width', '320')
      local_webcam.setAttribute('height', '240')

      var remote_webcam = document.getElementById(`webcam${self.sequence}`)
      remote_webcam.setAttribute('width', '320')
      remote_webcam.setAttribute('height', '240')

      // Show local video
      navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      }).then(stream => {
        document.getElementById(`local_webcam${self.sequence}`).srcObject = stream
        document.getElementById(`local_webcam${self.sequence}`).style.display = 'block'
      })
    },
    muteCall () {
      var self = this
      self.call.currentCall.setMute('toggle')
      self.call.mute = !self.call.mute
    },
    toggleCamera () {
      var self = this
      self.call.currentCall.setVideoMute('toggle')

      self.call.camera = !self.call.camera

      if (self.call.camera) {
        document.getElementById(`local_webcam${self.sequence}`).play()
      } else {
        document.getElementById(`local_webcam${self.sequence}`).pause()
      }
    },
    holdCall () {
      var self = this
      if (self.call.hold) {
        self.call.hold = false
        self.call.currentCall.unhold()

        if (self.call.isVideo) {
          self.call.currentCall.setVideoMute('toggle')
          document.getElementById(`local_webcam${self.sequence}`).play()
        }
      } else {
        self.call.hold = true
        self.call.currentCall.hold()

        if (self.call.isVideo) {
          self.call.currentCall.setVideoMute('toggle')
          document.getElementById(`local_webcam${self.sequence}`).pause()
        }
      }
    },
    transfer () {
      this.call.transferInitiated = true
    },
    cancelTransfer () {
      this.call.transferInitiated = false
    },
    transferCall () {
      var self = this
      self.call.transferInitiated = false
      self.call.currentCall.transfer(self.call.transferNumber)
    },
    completeAttendedTransfer () {
      var self = this
      self.completeAttendedTransferCall(self.call.attendedTransferInitiatorID, self.call.currentCall.params.callID)
    },
    mergeAttendedTransfer () {
      var self = this
      self.mergeAttendedTransferCall(self.call.attendedTransferInitiatorID, self.call.currentCall.params.callID)
    },
    cancelAttendedTransfer () {
      this.$refs['attendedTransfer'].hide()
    },
    toggleVideoTag () {
      var self = this

      if (!document.getElementById(`webcam${self.sequence}`)) {
        var webcam = document.createElement('video')
        webcam.setAttribute('id', `webcam${self.sequence}`)
        webcam.setAttribute('width', '0')
        webcam.setAttribute('height', '0')
        webcam.setAttribute('autoplay', true)

        document.getElementById(`webcam${self.sequence}div`).appendChild(webcam)
      }

      if (document.getElementById(`local_webcam${self.sequence}`)) {
        var tracks = null;
        var local = document.getElementById(`local_webcam${self.sequence}`)
        if (local.videoTracks && local.srcObject) {
          tracks = local.srcObject.getTracks()
        } else {
          tracks = local.captureStream().getTracks()
        }
        tracks.forEach(function (track) {
          track.stop()
        })
        document.getElementById(`local_webcam${self.sequence}div`).removeChild(document.getElementById(`local_webcam${self.sequence}div`).childNodes[0])
      }
      var localWebcam = document.createElement('video')
      localWebcam.setAttribute('id', `local_webcam${self.sequence}`)
      localWebcam.setAttribute('width', '0')
      localWebcam.setAttribute('height', '0')
      localWebcam.setAttribute('autoplay', true)

      document.getElementById(`local_webcam${self.sequence}div`).appendChild(localWebcam)
    },
    merge: async function () {
      var self = this
      var { activeCalls, activeCall } = await self.activeCalls()

      if (activeCalls > 1 && activeCall) {
        self.call.mergeCallee = activeCall
        self.$refs['mergeRequest'].show()
      } else {
        self.$refs['mergeNotAvailable'].show()
      }
    },
    cancelMergeRequest () {
      this.$refs['mergeRequest'].hide()
    },
    completeMergeRequest () {
      var self = this
      self.mergeCalls(self.call.mergeCallee.currentCall.params.callID, self.call.currentCall.params.callID)
    },
    cancelMergeNotAvailable () {
      this.$refs['mergeNotAvailable'].hide()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

body {
  background-color: #42a5f5;
}

.phone-container {
  padding: 0 0 !important;
  max-width: 420px !important;
  max-height: auto !important;
  text-align: center !important;
}

.phone-row {
  margin: 0px !important;
  max-width: 420px !important;
  clear: both !important;
  text-align: center !important;
  font-family: 'Exo' !important;
}

.overlay-alert {
  z-index: 2000;
  width: 100%;
  max-width: 420px !important;
  margin-left: -20px;
  opacity: .5;
  right: auto !important;
  left: auto !important;
}

.phone-row-voice {
  margin: 20px auto !important;
  max-width: 600px !important;
  clear: both !important;
  text-align: center !important;
  font-family: 'Exo' !important;
}

</style>
